import React, { useState, SyntheticEvent } from 'react';
import { Button, Popover, TextInput } from '@ems/client-design-system';
import { chevronIcon, crossIcon, searchIcon } from './icons';
import { PopoverInteractionKind } from '@blueprintjs/core';
import { IIDFilter } from './interfaces';

export const IDFilter = ({
  value,
  onChange,
  onSubmit,
  selectedID,
  onClearSelect,
  languageData,
  categoryName,
}: IIDFilter) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onPopoverClick = (nextOpenState: boolean, event?: SyntheticEvent<HTMLElement>) => {
    if (typeof event !== 'undefined' && event.type === 'mousedown') {
      setIsOpen(false);
    }
  };

  const onButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const onFormSubmit = () => {
    if (value !== '') {
      onSubmit();
      setIsOpen(false);
    }
  };

  const getTitle = () => {
    const { title } = languageData;

    if (selectedID) {
      const displayValue = selectedID.length > 5 ? `${selectedID.substring(0, 5)}...` : selectedID;
      return (
        <>
          <span className="filter_button--category filter_button--textonly">{title}: </span>
          <span className="filter_button--items">{displayValue}</span>
        </>
      );
    }
    return <span className="filter_button--category">{title}</span>;
  };

  return (
    <Popover
      isOpen={isOpen}
      interactionKind={PopoverInteractionKind.CLICK}
      onInteraction={onPopoverClick}
      position="bottom-left"
      transitionDuration={0}
      autoFocus>
      <Button
        className="filter-category-button"
        style="subtle"
        rightIcon={chevronIcon}
        onClick={onButtonClick}
        aria-label={`${categoryName} filter`}>
        {getTitle()}
      </Button>
      <div className="filter-popover-content">
        <div
          className={`filter-search filter-string-search ${categoryName
            .toLowerCase()
            .replace(/\s/g, '-')}-search`}>
          <TextInput
            icon={searchIcon}
            value={value}
            onChange={onChange}
            onPressEnter={onFormSubmit}
            placeholder={''}
            autoFocus
          />
          {selectedID && (
            <Button
              style="subtle"
              rightIcon={crossIcon}
              onClick={onClearSelect}
              aria-label={`Clear ${categoryName} filter`}
            />
          )}
          <Button style="primary" onClick={onFormSubmit} aria-label={`${categoryName} filter`}>
            Set
          </Button>
        </div>
      </div>
    </Popover>
  );
};
